"use client";
import { useScrollReveal } from "@/hooks/common/useScrollReveal";
import GcsImage from "@/components/common/GcsImage";
import { aboutPhoto1, aboutPhoto2 } from "@/lib/gcsImagePaths";
import { aboutPhoto3, cornerShield } from "@/lib/gcsImagePaths";

export default function Gallery() {
  const { ref, isVisible } = useScrollReveal();

  return (
    <section
      ref={ref}
      className={`py-0 transition-all duration-700 ${
        isVisible ? "animate-fade-in" : "opacity-0"
      }`}
    >
      <div className="w-full">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-1 md:gap-2">
          <div className="aspect-square overflow-hidden">
            <GcsImage
              path={aboutPhoto1}
              alt="Team members standing together in modern office space"
              className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
            />
          </div>
          <div className="aspect-square overflow-hidden">
            <GcsImage
              path={aboutPhoto2}
              alt="Team member engaging with office environment"
              className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
            />
          </div>
          <div className="relative aspect-square overflow-hidden">
            <GcsImage
              path={aboutPhoto3}
              alt="Team members gathered in modern office meeting space"
              className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
            />
            <GcsImage
              path={cornerShield}
              alt="Decorative shield"
              className="absolute bottom-0 right-0 w-24 md:w-32 h-auto"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
